//import { useState } from "react";
import { ResponsivePie } from "@nivo/pie";

interface PieData {
  id: string;
  value: number;
}

const data: PieData[] = [
  { id: "USA", value: 500 },
  { id: "China", value: 300 },
  { id: "Japan", value: 200 },
  { id: "Germany", value: 100 },
];

export default function Chart3() {
  // const getColor = (id: string) => {
  //   const colors: Record<string, string> = {
  //     USA: "#7916ff",
  //     China: "#843dff",
  //     Japan: "#9f75ff",
  //     Germany: "#bea6ff",
  //   };
  //   return colors[id] || "#843DFF";
  // };
  //const [hoveredId, setHoveredId] = useState<string | null>(null);

  return (
    <>
      <ResponsivePie
        data={data}
        margin={{ top: 50, right: 50, bottom: 50, left: 50 }}
        innerRadius={0.5}
        padAngle={0.7}
        cornerRadius={3}
        //colors={({ id }) => (id === hoveredId ? "#4b05ad" : getColor(id))}
        colors={["#42a5f5", "#32CD32", "#2e7d32", "#1565c0"]}
        // colorBy="index"
        borderWidth={1}
        borderColor={{ from: "color", modifiers: [["darker", 0.2]] }}
        animate={true}
        motionConfig="slow"
        //onMouseLeave={() => setHoveredId(null)}
        tooltip={({ datum }) => (
          <div
            style={{
              borderRadius: "0.75rem",
              border: "1px solid #e5e7eb",
              backgroundColor: "#ffffff",
              padding: "1rem",
              boxShadow:
                "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "1rem",
              }}
            >
              <div
                style={{
                  width: "0.25rem",
                  borderRadius: "0.25rem",
                  alignSelf: "stretch",
                  backgroundColor: "#7E7988",
                }}
              ></div>
              <div style={{ flex: 1 }}>
                <strong
                  style={{
                    display: "block",
                    fontWeight: 500,
                    fontSize: "1rem",
                    lineHeight: "1rem",
                    color: "#9d99a8",
                  }}
                >
                  {datum.id}
                </strong>
                <span
                  style={{
                    fontSize: "1.125rem",
                    lineHeight: "1.875rem",
                    color: "#1e1c24",
                  }}
                >
                  Value: <span style={{ fontWeight: 600 }}>{datum.value}</span>
                </span>
              </div>
            </div>
          </div>
        )}
        arcLinkLabelsSkipAngle={3}
        arcLinkLabelsTextColor="#77767b"
        arcLinkLabelsThickness={2}
        arcLinkLabelsColor={{ from: "color" }}
        arcLabelsSkipAngle={10}
        arcLabelsTextColor={{
          from: "color",
          modifiers: [["darker", 2]],
        }}
        theme={{
          axis: {
            ticks: {
              text: {
                fill: "#7E7988",
              },
            },
            domain: {
              line: {
                stroke: "#e0e0e0",
                strokeWidth: 1,
              },
            },
          },
          grid: {
            line: {
              stroke: "#F3F3F4",
              strokeWidth: 1,
            },
          },
        }}
        legends={[
          {
            anchor: "top-right",
            direction: "column",
            justify: false,
            translateX: 60,
            translateY: -50,
            itemsSpacing: 0,
            itemWidth: 100,
            itemHeight: 18,
            itemTextColor: "#999",
            itemDirection: "left-to-right",
            itemOpacity: 1,
            symbolSize: 12,
            symbolShape: "circle",
            effects: [
              {
                on: "hover",
                style: {
                  itemTextColor: "#000",
                },
              },
            ],
          },
        ]}
      />
    </>
  );
}
